<template>
    <div class="row">
        <div class="col-12">
            <h4>Personal Info</h4>
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-lg-2">
            <div class="form-group">
                <label for="salutation" class="input-label">Salutation</label>
                <select class="custom-select form-control-sm"
                        id="salutation"
                        v-model="person.salutation">
                    <option :value="'Mr.'">Mr</option>
                    <option :value="'Mrs'">Mrs</option>
                    <option :value="'Ms'">Ms</option>
                </select>
            </div>
        </div>
        
        <div class="col-12 col-md-6 col-lg-4">
            <form-input :placeholder="$t('COMMON.firstName')"
                        :elementID="'firstName'"
                        :containerClass="'form-group'"
                        :inputClass="'form-control-sm'"
                        :inputType="'text'"
                        :validator="$v.person.firstName"
                        v-model="person.firstName">
            </form-input>
        </div>
        
        <div class="col-12 col-md-6 col-lg-4">
            <form-input :placeholder="$t('COMMON.lastName')"
                        :elementID="'lastName'"
                        :containerClass="'form-group'"
                        :inputClass="'form-control-sm'"
                        :inputType="'text'"
                        :validator="$v.person.lastName"
                        v-model="person.lastName">
            </form-input>
        </div>
    </div>
</template>
<script>
import FormInput from '../../../../../Shared/UI/Form/FormInput.vue';
import {required} from 'vuelidate/lib/validators';

export default {
    name: 'personal-data',
    components: {FormInput},
    props: {
        person: {},
        salutations: {}
    },
    validations: {
        person: {
            salutation: {
                required
            },
            firstName: {
                required
            },
            lastName: {
                required
            }
        }
    }
    
};
</script>
